"use client";
import { useAtomValue } from "jotai";
import { isAdminNavbarOpened, isMobileAtom } from "../../store/layoutStore";
import { Suspense, lazy } from "react";
import { userAtom } from "../../store/userAtom";
import { adminNavbarRoutes } from "../../utils/navbarRoutes";
const NavbarDesktop = lazy(() => import("./NavbarDesktop"));
const NavbarMobile = lazy(() => import("./NavbarMobile"));
const AdminSubNavBar = () => {
  const isMobile = useAtomValue(isMobileAtom);

  const user = useAtomValue(userAtom);
  const isAdminNavbarOpenedValue = useAtomValue(isAdminNavbarOpened);

  if (user?.isAdmin && isAdminNavbarOpenedValue)
    return (
      <Suspense>
        {isMobile ? (
          <NavbarMobile routes={adminNavbarRoutes} />
        ) : (
          <NavbarDesktop routes={adminNavbarRoutes} />
        )}
      </Suspense>
    );
  return null;
};

export default AdminSubNavBar;
